import React, { useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import Styles from "./LoginOrRegister.module.scss";
import classNames from "classnames";
import { useTheme } from "@/shared/styles/useTheme";
import FormContext from "@/auth/state/FormContext";

const RegistrationSuccess = ({ mode }: { mode: "Navbar" | "SOF" | "CSF" }) => {
  const { t } = useTranslation();
  const { state } = useContext(FormContext);
  const { primaryColorBorder, primaryColor } = useTheme();

  const titles = {
    SOF: {
      successTitle: t("registrationSuccess.successTitleSOF"),
      successMessage: "registrationSuccess.successMessageSOF",
      footerMessage: "registrationSuccess.footerMessageSOF",
    },
    CSF: {
      successTitle: t("registrationSuccess.successTitleCSF"),
      successMessage: "registrationSuccess.successMessageCSF",
      footerMessage: "registrationSuccess.footerMessageCSF",
    },
    Navbar: {
      successTitle: t("registrationSuccess.successTitleNavbar"),
      successMessage: "registrationSuccess.successMessageNavbar",
      footerMessage: "registrationSuccess.footerMessageNavbar",
    },
  };

  const currentTitles = titles[mode] || titles.Navbar;

  return (
    <div className={classNames(Styles.MagicLinkContainer, Styles.MsgContainer, Styles.registrationSuccess)}>
      <div className={classNames(Styles.form, primaryColorBorder, Styles.magicForm)}>
        <form>
          <h1 className={Styles.successTitle}>{currentTitles.successTitle}</h1>
          <div className={Styles.fieldWrapper}>
            <Trans
              i18nKey={currentTitles.successMessage}
              values={{
                email: state?.values?.email,
              }}
            >
              <strong>{state?.values?.email}</strong>
              <b />
            </Trans>
          </div>
        </form>
      </div>
      <footer className={Styles.footer}>
        <p>
          <Trans i18nKey={currentTitles.footerMessage}>
            <b />
            <a href="mailto:service@remind.me" className={primaryColor} />
          </Trans>
        </p>
      </footer>
    </div>
  );
};

export default RegistrationSuccess;
